import { photoViewerBasePath } from 'components/page/PhotoViewer/PhotoViewer.paths'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { useAuthorizationPath } from 'hooks/useAuthorizationLink'
import { useLayoutContext } from 'hooks/useLayoutContext'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

export const useIncognitoBaseUrl = (incognito: boolean): string => {
  const { authorized } = useShallowEqualSelector(
    ({ authorizationReducer: { authorized } }) => ({
      authorized,
    })
  )

  /**
   * Если у пользователя включен режим инкогнито, то
   * мы не должны позволить анонимному пользователю нажать на фотку, а
   * должны отправить на авторизацию.
   * Если пользователь не анонимный то вернуть базовый url на photoviewer
   */
  const { baseUrl } = useLayoutContext()
  const authorizationPath = useAuthorizationPath()
  const baseAuthorizedUrl = mergeAllUrls(baseUrl, photoViewerBasePath)

  return !authorized && incognito ? authorizationPath : baseAuthorizedUrl
}
